import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  createRef,
} from "react";
import Button, { ButtonProps } from "./Button";
import Icon from "./Icon";
import ArrowDownIcon from "../icons/ArrowDownIcon";
import ArrowUpIcon from "../icons/ArrowUpIcon";

export type OptionTypes = {
  label: string;
  id: string;
};
interface IButtonWithDropdown extends ButtonProps {
  options: Array<OptionTypes>;
}

const ButtonWithDropdown: React.FC<IButtonWithDropdown> = ({
  children,
  options = [],
  onClick,
  id,
  ...rest
}): React.ReactElement => {
  const [isShowOptions, toggleOption] = useState<string>("hidden");
  const menuRef: any = useRef();

  const showOption = (e: any) => {
    e.preventDefault();
    console.log('coming here')
    toggleOption((prev: string) => {
      console.log('pre', prev);
      return prev === "hidden" ? "show" : "hidden"
    });
  };

  const handleClick = (e: any) => {
    if (onClick) onClick(e);
    showOption(e);
  };

  useEffect(() => {
    window.addEventListener("click", (e: any) => {
      const cur: any = menuRef.current;
      const node: any = e.target;
      if (cur && cur.contains(node)) return;
      toggleOption("hidden");
    });
  }, []);

  return (
    <div ref={menuRef} className="inline">
      <Button onClick={showOption} {...rest}>
        <div className="flex items-center text-white">
          {children}
          <Icon
            width="15"
            height="15"
            name={isShowOptions === "hidden" ? "ArrowDown" : "ArrowUp"}
          />
        </div>
      </Button>
      <div
        className={`${isShowOptions} flex absolute bg-neutral text-sm w-52 mt-1 max-h-72 overflow-y-auto rounded-md`}
      >
        <ul className="w-full cursor-pointer">
          {options.map((option: OptionTypes, key: number) => (
            <li
              key={option.label}
              value={option.label}
              id={option.id}
              className={`py-3 px-3 hover:bg-primary text-white ${
                key !== options.length - 1 ? "border-b border-solid border-gray-600" : ""
              } w-full min-h-16`}
              onClick={handleClick}
            >
              {option.label}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ButtonWithDropdown;
